var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 383 c-12 -11 -7 -78 9 -133 31 -106 121 -160 264 -160 90 0 147 29 178 90 30 59 27 114 -7 118 -43 7 -91 -9 -127 -40 -19 -17 -36 -29 -38 -27 -1 2 -8 19 -16 37 -18 46 -71 89 -132 107 -53 16 -120 20 -131 8z m166 -55 c22 -13 50 -38 60 -56 19 -33 41 -111 33 -119 -2 -2 -26 19 -54 46 -27 28 -54 51 -61 51 -23 0 -9 -26 42 -78 l52 -54 -40 7 c-110 19 -175 96 -175 209 0 29 0 29 51 23 27 -4 69 -17 92 -29z m274 -94 c-8 -50 -32 -83 -74 -100 -47 -20 -52 -11 -14 26 17 17 31 36 31 41 0 18 -27 8 -55 -21 -35 -37 -41 -33 -21 14 17 41 68 76 110 76 27 0 28 -2 23 -36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.09405ee2aa63c969fc001a9872bc2692.svg";
export { ForwardRef as ReactComponent };